// @ts-nocheck
import React, { Component } from 'react';
import { Link } from '../../lib/routerAdapter';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';
import qs from 'query-string';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import { accessTypeEnum } from '../../lib/enum';
import { userApi } from '../../lib/api';
import { convertEmployeeToString, getListInitialState } from '../../lib/helpers';
import { fetchListWithLifecycle } from '../../lib/listController';
import { Popconfirm, Icon, Operations, Table } from './../../components/ui';
import { Section } from './../../components/layout';
import Header from '../../components/layout/Header';
import { notificationLoading } from './../../components/Notifications';
import { withUserAccess } from '../withUserAccess';
import Filter from './Filter';
export class UserList extends Component {
  state = {
    ...getListInitialState(),
    filter: {},
    columns: [{
      title: 'Логин',
      dataIndex: 'userName',
      sorter: true
    }, {
      title: 'Роль',
      dataIndex: 'roleName',
      sorterKey: 'role.name',
      sorter: true
    }, {
      title: 'ФИО',
      dataIndex: 'employee',
      sorter: true,
      sorterKey: 'employee.person.lastName',
      render: employee => convertEmployeeToString(employee)
    }, {
      title: 'Подразделение',
      dataIndex: 'employee.orgUnitName',
      sorter: true,
      sorterKey: 'employee.node.name'
    }]
  };
  static defaultProps = {
    location: {}
  };
  async deleteUser(id) {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await userApi.deleteUser(id);
      await this.fetchUsers(this.state.page);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  }
  handleRowClick = id => navigate(`/admin/users/${id}`);
  fetchUsers = (page = 1, params = {}) => {
    const {
      filter
    } = this.state;
    return fetchListWithLifecycle({
      page,
      pageSize: this.state.pageSize,
      params,
      fetchPage: (requestedPage, requestParams) =>
        userApi.fetchUsers({
          ...filter,
          ...requestParams,
          page: requestedPage,
        }),
      setState: (patch) => this.setState(patch),
    });
  };
  cleanFilter = () => this.setState({
    filter: {}
  }, this.fetchUsers);
  applyFilter = filter => this.setState({
    filter
  }, this.fetchUsers);
  async componentDidMount() {
    const {
      columns
    } = this.state;
    const {
      page,
      ...filter
    } = qs.parse(window.location.search);
    this.setState({
      filter
    }, () => this.fetchUsers(page));
    if (this.canAdd()) {
      this.setState({
        columns: [...columns, {
          title: ' ',
          dataIndex: 'id',
          // eslint-disable-next-line no-unused-vars
          render: (text, record) => <Operations>
                <Popconfirm title="Вы действительно хотите удалить?" okText="Да" cancelText="Нет" onConfirm={async () => await this.deleteUser(record.id)}>
                  <StyledIcon type="x" />
                </Popconfirm>
              </Operations>
        }]
      });
    }
  }
  canAdd = () => this.props.userAccess.some(access => [accessTypeEnum.admin, accessTypeEnum.adminBranch, accessTypeEnum.handlingUsersAndRoles].includes(access));
  render() {
    const {
      location
    } = this.props;
    const {
      data,
      totalCount,
      pageSize,
      page,
      filter,
      loading,
      columns
    } = this.state;
    const canAdd = this.canAdd();
    return <>
        <Header left={<h1>Пользователи</h1>} right={canAdd && <Link to="/admin/users/new">
                <Button type="primary" data-cy="addUser">
                  Создать
                </Button>
              </Link>} />
        <Section>
          <Filter filter={filter} applyFilter={this.applyFilter} cleanFilter={this.cleanFilter} />
          <Table columns={columns} onRow={record => ({
          onClick: () => this.handleRowClick(record.id)
        })} fetch={this.fetchUsers} loading={loading} pagination={{
          page,
          pageSize,
          totalCount,
          location
        }} data={data} />
        </Section>
      </>;
  }
}
const StyledIcon = styled(Icon).withConfig({
  displayName: "UserList__StyledIcon",
  componentId: "sc-107rvur-0"
})(["margin:0 5px;color:#1890ff;cursor:pointer;"]);
export default withUserAccess(UserList);
